module.exports = __webpack_public_path__ + "202408221624/img/dazhaohu.5b336528.png";